import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProperties,
  deleteProperty,
} from "../../redux/slices/propertySlice";
import PropertyForm from "./PropertyForm";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
import { FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios";
import { ADMINS_AND_MANAGERS } from "../../constants/roles";
import { userHasAnyRole } from "../../utils/leadershipRoles";

import { getPropertyDocumentCount } from "../../api/documentApi";

import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";


export default function PropertyList({ user, onLogout }) {
  user = JSON.parse(localStorage.getItem("user"));
  const isAdminUser = userHasAnyRole(user, ADMINS_AND_MANAGERS);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const properties = useSelector((state) => state.property.list) || {
    data: [],
  };
  const status = useSelector((state) => state.property.status);

  const [showForm, setShowForm] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const [documentCounts, setDocumentCounts] = useState({});

  const tableRef = useRef(null);
  console.log("properties list>>>>>>>>", properties, status);
  // Fetch property data
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchProperties());
    }
  }, [status, dispatch]);

  // Fetch document counts for all properties
  useEffect(() => {
    const fetchDocumentCounts = async () => {
      if (!properties?.data || properties.data.length === 0) return;

      const counts = {};
      try {
        await Promise.all(
          properties.data.map(async (property) => {
            try {
              const response = await getPropertyDocumentCount(property.id);
              counts[property.id] = response.document_count || 0;
            } catch (error) {
              console.error(`Error fetching document count for property ${property.id}:`, error);
              counts[property.id] = 0;
            }
          })
        );
        setDocumentCounts(counts);
      } catch (error) {
        console.error("Error fetching document counts:", error);
      }
    };

    if (properties?.data && properties.data.length > 0) {
      fetchDocumentCounts();
    }
  }, [properties]);

  // Initialize & update DataTable safely
  useEffect(() => {
    if (!properties?.data) return;

    // Initialize DataTable only once
    if (!$.fn.DataTable.isDataTable("#propertyTable")) {
      tableRef.current = $("#propertyTable").DataTable({
        responsive: true,
        autoWidth: false,
        pageLength: 8,
      });
    }

    // Update rows
    const dt = $("#propertyTable").DataTable();
    dt.clear();
    dt.rows.add(
      (properties.data || []).map((p, index) => {
        // Extract primary photo or first photo
        let imageHtml = "No Image";
        if (p.photos && Array.isArray(p.photos) && p.photos.length > 0) {
          const primaryPhoto = p.photos.find(photo => photo.is_primary) || p.photos[0];
          const photoUrl = primaryPhoto.file_path.startsWith("http")
            ? primaryPhoto.file_path
            : `${api.defaults.baseURL}/${primaryPhoto.file_path}`;
          imageHtml = `<img src="${photoUrl}" alt="${p.name}" 
              style="width:70px;height:50px;object-fit:cover;border-radius:6px;" />`;
        }

        return [
          index + 1,
          imageHtml,
          p.name,
          p.type?.name || "",
          p.status?.status_type || "",
          `<div class="d-flex gap-1 flex-wrap">
            <button class="btn btn-outline-info btn-sm view-btn" data-id="${p.id
          }">
              <i class="fa fa-eye"></i> View
            </button>
            ${isAdminUser
            ? `<button class="btn btn-outline-primary btn-sm document-btn" data-id="${p.id}" title="Manage Documents">
                     <i class="fa fa-file-upload"></i> ${(documentCounts[p.id] || 0) > 0 ? `${documentCounts[p.id]} Docs` : 'Upload'}
                   </button>
                   <button class="btn btn-outline-success btn-sm edit-btn" data-id="${p.id}">
                     <i class="fa fa-edit"></i>
                   </button>
                   <button class="btn btn-outline-danger btn-sm delete-btn" data-id="${p.id}">
                     <i class="fa fa-trash"></i>
                   </button>`
            : ""
          }
        </div>`,
        ];
      })
    );
    dt.draw();

    // Handle button events
    $("#propertyTable")
      .off("click", ".view-btn")
      .on("click", ".view-btn", function () {
        const id = $(this).data("id");
        const prop = (properties.data || []).find((p) => p.id === id);
        console.log("Property view", prop);
        if (id) navigate(`/properties/${id}`, { state: { property: prop } });
      });

    $("#propertyTable")
      .off("click", ".edit-btn")
      .on("click", ".edit-btn", function () {
        const id = $(this).data("id");
        const prop = (properties.data || []).find((p) => p.id === id);
        if (prop) {
          console.log("prop", prop);
          setSelectedProperty(prop);
          console.log("selectedProperty", selectedProperty);
          setShowForm(true);
        }
      });

    $("#propertyTable")
      .off("click", ".delete-btn")
      .on("click", ".delete-btn", function () {
        const id = $(this).data("id");
        if (id) {
          const prop = (properties.data || []).find((p) => p.id === id);
          if (prop) {
            setPropertyToDelete(prop);
            setShowDeleteModal(true);
          }
        }
      });

    // Handle document button click
    $("#propertyTable")
      .off("click", ".document-btn")
      .on("click", ".document-btn", function () {
        const id = $(this).data("id");
        if (id) {
          navigate(`/documentManagement?property_id=${id}&type=property`);
        }
      });
  }, [properties, dispatch, isAdminUser, navigate, documentCounts]);

  const handleAdd = () => {
    setSelectedProperty(null);
    setShowForm(true);
  };

  const handleDeleteConfirm = async () => {
    if (!propertyToDelete) return;

    try {
      await dispatch(deleteProperty(propertyToDelete.id)).unwrap();
      toast.success("Property deleted successfully!");
      dispatch(fetchProperties());
      setShowDeleteModal(false);
      setPropertyToDelete(null);
    } catch (error) {
      toast.error("Failed to delete property!");
    }
  };

  return (
    <>
      <div className="container-fluid">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="h2 fw-bold">Property List</h1>
          {isAdminUser && (
            <button
              className="btn btn-primary d-flex align-items-center"
              onClick={handleAdd}
            >
              <FaPlus className="me-2" /> Add Property
            </button>
          )}
        </div>

        {/* Property Form Modal */}
        {showForm && (
          <PropertyForm
            property={selectedProperty}
            onClose={() => setShowForm(false)}
            onSaved={() => dispatch(fetchProperties())}
          />
        )}

        {/* Delete Confirmation Modal */}
        {showDeleteModal && propertyToDelete && (
          <DeleteConfirmationModal
            show={showDeleteModal}
            onClose={() => {
              setShowDeleteModal(false);
              setPropertyToDelete(null);
            }}
            onConfirm={handleDeleteConfirm}
            title="Delete Property"
            message={`Are you sure you want to delete "${propertyToDelete.name}"? This action cannot be undone.`}
          />
        )}

        {/* Table */}
        {status === "loading" ? (
          <p>Loading...</p>
        ) : (
          <div className="table-responsive">
            <table
              id="propertyTable"
              className="table table-striped table-bordered align-middle w-100"
            >
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
